var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{class:{ 'arabic-font': !_vm.$isEn }},[_c('AppHeader'),(true)?_c('v-main',[_c('router-view')],1):_vm._e(),_c('AppFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }